import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "ma-2" }
const _hoisted_2 = { class: "primary--text text-h6 font-weight-bold" }
const _hoisted_3 = { width: "70vw" }
const _hoisted_4 = { style: {"height":"60vh","width":"100vw"} }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_profile = _resolveComponent("profile")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_WorkingTime = _resolveComponent("WorkingTime")!
  const _component_tutorials = _resolveComponent("tutorials")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "close-on-content-click": false,
    "nudge-width": 200,
    "offset-x": "",
    location: "start"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: _withCtx(({ props: propsTooltip }) => [
          _createElementVNode("div", _normalizeProps(_guardReactiveProps(propsTooltip)), [
            _createVNode(_component_v_badge, {
              dot: "",
              modelValue: _ctx.showUpgradeUI,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showUpgradeUI) = $event)),
              floating: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, _mergeProps({ color: _ctx.avatarColor }, props, {
                  density: "comfortable",
                  style: _ctx.topButtonStyle,
                  "data-cy": "profileMenu-showUserProfile"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getUserBigram(_ctx.currentUser)), 1)
                  ]),
                  _: 2
                }, 1040, ["color", "style"])
              ]),
              _: 2
            }, 1032, ["modelValue"])
          ], 16)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.avatarTitle), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card, {
          class: "rounded-lg",
          elevation: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, { class: "mb-n2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, null, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      color: "#EAEAEA",
                      small: "",
                      size: "36"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getUserBigram(_ctx.currentUser)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                          _createVNode(_component_v_chip, {
                            "x-small": "",
                            dark: "",
                            label: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickProfileRulesDialog())),
                            color: "primary",
                            variant: "outlined"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.avatarTitle), 1)
                            ]),
                            _: 1
                          })
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createElementVNode("span", null, "Voir les droits du profil", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "d-flex" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getUserDisplayName(_ctx.currentUser)), 1),
                        _createVNode(_component_v_spacer)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentUser?.company?.name || ""), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getDisplayEmail(_ctx.currentUser?.email)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "mx-4" }),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (!_ctx.isInInternalManagement)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      ripple: "",
                      onClick: _ctx.openProfileDialog
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "small",
                          icon: "$fa-user-cog"
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode(" Voir la page en tant que ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.showUpgradeUI)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 1,
                      ripple: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.upgradeUi()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, {
                          class: "text-decoration-underline",
                          style: {"cursor":"pointer"}
                        }, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createTextVNode(" Mettre à jour bobbee maintenant ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showInstallPWA)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 2,
                      ripple: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.installPWA()))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "small",
                          icon: "$fa-download"
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                            _createTextVNode(" Installer bobbee ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isAccountingUser)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 3,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activateUserWorkingTime = true))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "small",
                          icon: "$fa-business-time"
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                            _createTextVNode(" Suivi des temps ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_list_item, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.passwordChange = true))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      icon: "$fa-lock"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode(" Changer de mot de passe ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activateVersionsDialog = true))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      icon: "$fa-redo"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode(" Les mises à jour ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, { onClick: _ctx.onKnowledgeBaseClicked }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      icon: "$fa-atlas"
                    }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("$fa-atlas")
                      ])),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode(" La base de connaissance ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_list_item, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openTutorialsDialog(null)))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      icon: "$fa-shoe-prints"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode(" Les tutoriels « pas à pas » ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn_primary, {
          block: "",
          onClick: _ctx.logout,
          "data-cy": "profileMenu-logout",
          size: "large",
          class: "error mt-2",
          elevation: "1"
        }, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [
            _createTextVNode("Se déconnecter")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_oss_dialog, {
        title: "Droits du profil",
        modelValue: _ctx.showProfileRulesDialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showProfileRulesDialog) = $event)),
        "min-width": "70vw"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_profile, {
              profileId: _ctx.profileId,
              isConsultation: true
            }, null, 8, ["profileId"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.passwordChange,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.passwordChange) = $event)),
        persistent: _ctx.firstLoginDialog,
        title: "Changer votre mot de passe",
        validText: "Modifier",
        onValid: _ctx.changePassword,
        width: "40vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, { ref: "form" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "py-1"
              }, {
                default: _withCtx(() => [
                  (_ctx.firstLoginDialog)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode(" Afin de garantir la sécurité de votre compte, merci de créer une nouveau mot de passe ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        required: "",
                        type: _ctx.showPasswordPrevious ? 'text' : 'password',
                        "append-inner-icon": 
                                _ctx.showPasswordPrevious ? '$oss-eye' : '$oss-eye-slash'
                            ,
                        rules: [() => _ctx.previousPassword.length > 0 || 'empty password'],
                        onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                        label: "Mot de passe actuel",
                        modelValue: _ctx.previousPassword,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.previousPassword) = $event)),
                        density: "compact",
                        "onClick:appendInner": _cache[10] || (_cache[10] = ($event: any) => (_ctx.showPasswordPrevious = !_ctx.showPasswordPrevious))
                      }, null, 8, ["type", "append-inner-icon", "rules", "onKeyup", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        required: "",
                        type: _ctx.showPassword ? 'text' : 'password',
                        "append-inner:icon": _ctx.showPassword ? '$oss-eye' : '$oss-eye-slash',
                        rules: [
                                () => _ctx.password.length > 0 || 'empty password',
                                () =>
                                    _ctx.password === _ctx.pwdConfirmation ||
                                    !(_ctx.pwdConfirmation.length > 0) ||
                                    'Passwords does not match',
                            ],
                        onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                        label: "Nouveau mot de passe",
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.password) = $event)),
                        density: "compact",
                        "onClick:appendInner": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                      }, null, 8, ["type", "append-inner:icon", "rules", "onKeyup", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        required: "",
                        type: "password",
                        rules: [
                                () => _ctx.pwdConfirmation.length > 0 || 'empty password',
                                () =>
                                    _ctx.password === _ctx.pwdConfirmation ||
                                    !(_ctx.password.length > 0) ||
                                    'Passwords does not match',
                            ],
                        onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                        label: "Confirmer votre mot de passe",
                        modelValue: _ctx.pwdConfirmation,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pwdConfirmation) = $event))
                      }, null, 8, ["rules", "onKeyup", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_v_alert, {
            type: "success",
            value: _ctx.isPasswordModified
          }, {
            default: _withCtx(() => [
              _cache[36] || (_cache[36] = _createTextVNode(" Votre mot de passe a bien été modifié ")),
              _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_router_link, { to: '/login' }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("Se connecter")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue", "persistent", "onValid"]),
      (_ctx.activateUserWorkingTime)
        ? (_openBlock(), _createBlock(_component_WorkingTime, {
            key: 0,
            modelValue: _ctx.activateUserWorkingTime,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.activateUserWorkingTime) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!_ctx.emailVerification && !_ctx.isAuth())
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            onKeydown: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.activateHelp = false), ["esc"])),
            onPrevious: _cache[17] || (_cache[17] = ($event: any) => (_ctx.tutorialBack())),
            title: "Tutoriels",
            modelValue: _ctx.activateHelp,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.activateHelp) = $event)),
            "max-width": _ctx.$vuetify.display.mobile ? 'auto' : '70vw'
          }, {
            default: _withCtx(() => [
              (_ctx.activateHelp)
                ? (_openBlock(), _createBlock(_component_tutorials, {
                    key: 0,
                    ref: "tutorialWizard",
                    tutorials: _ctx.tutorials
                  }, null, 8, ["tutorials"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "max-width"]))
        : _createCommentVNode("", true),
      (!_ctx.emailVerification && !_ctx.isAuth())
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            onKeydown: _cache[19] || (_cache[19] = _withKeys(($event: any) => (_ctx.activateHelp = false), ["esc"])),
            title: "Les mises à jour",
            modelValue: _ctx.activateVersionsDialog,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.activateVersionsDialog) = $event)),
            "max-width": _ctx.$vuetify.display.mobile ? 'auto' : '70vw'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("iframe", {
                  style: {"height":"60vh","width":"100vw"},
                  frameBorder: "0",
                  src: _ctx.versionsEmbededPath
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "max-width"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.activateProfileDialog,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.activateProfileDialog) = $event)),
        title: "Voir la page en tant que",
        validText: "Changer",
        onValid: _ctx.changeProfile,
        width: "40vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "mb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "10",
                class: "pr-1"
              }, {
                default: _withCtx(() => [
                  (_ctx.availableProfiles && _ctx.availableProfiles.length)
                    ? (_openBlock(), _createBlock(_component_v_select_filled, {
                        key: 0,
                        modelValue: _ctx.profileId,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.profileId) = $event)),
                        items: _ctx.availableProfiles,
                        "item-title": _ctx.getProfileName,
                        "item-value": "id",
                        label: "Profil utilisateur",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto"
                      }, null, 8, ["modelValue", "items", "item-title"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({
                        icon: "$fa-redo",
                        onClick: _ctx.resetProfile
                      }, props), null, 16, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _cache[38] || (_cache[38] = _createElementVNode("span", null, "Réinitialiser", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"])
    ]),
    _: 1
  }))
}